// src/types/UiState.ts
import type { DeleteSixPayload } from '@/types/create-six.types';
import type { DeleteFilePayload } from '@/types/six/SixDTOs';

export interface ModalPayload {
  modal: string;
  modalProps?: Record<string, unknown> | undefined;
}

export type SixConfirmKind = 'delete';
export type FileConfirmKind = 'delete';
export type FolderConfirmKind = 'delete';

export interface DeleteFolderPayload {
  sixId: string;
  folderPath: string;
  folderName: string;
}

export type UiConfirmState =
  | {
      context: 'sixes';
      kind: SixConfirmKind;
      row: { id: string; name: string };
      payload: DeleteSixPayload;
    }
  | {
      context: 'files';
      kind: FileConfirmKind;
      row: { id: string; name: string };
      payload: DeleteFilePayload;
    }
  | {
      context: 'folders';
      kind: FolderConfirmKind;
      row: { id: string; name: string };
      payload: DeleteFolderPayload;
    };

export interface UiState {
  modal: ModalPayload['modal'] | null;
  modalProps?: ModalPayload['modalProps'];
  confirm: UiConfirmState | null;
  showLoader: boolean;
  errorMessage: string | null;
  pollingModal: {
    type: 'success' | 'error' | null;
    title?: string;
    message?: string;
    resourceUrl?: string | null;
    details?: Record<string, unknown> | null;
  };
}

export const initialUiState: UiState = {
  modal: null,
  modalProps: undefined,
  confirm: null,
  showLoader: false,
  errorMessage: null,
  pollingModal: { type: null },
};
